module.exports = __webpack_public_path__ + "img/9788995683668.4bb42493.jpg";